// states/useLeagueListState.js
import { useState } from "react";

export const useLeagueListState = () => {
  const [playCricketCompetitions, setPlayCricketCompetitions] = useState([]);
  const [playCricketLoading, setPlayCricketLoading] = useState(true);
  const [playCricketError, setPlayCricketError] = useState(null);
  const [leagueData, setLeagueData] = useState([]);
  const [filteredLeagues, setFilteredLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [searchTerm, setSearchTerm] = useState("");
  const [loadedYears, setLoadedYears] = useState(new Set());
  const [yearsList, setYearsList] = useState([]);

  return {
    playCricketCompetitions,
    setPlayCricketCompetitions,
    playCricketLoading,
    setPlayCricketLoading,
    playCricketError,
    setPlayCricketError,
    leagueData,
    setLeagueData,
    filteredLeagues,
    setFilteredLeagues,
    loading,
    setLoading,
    selectedYear,
    setSelectedYear,
    searchTerm,
    setSearchTerm,
    loadedYears,
    setLoadedYears,
    yearsList,
    setYearsList,
  };
};